var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{class:['kion-button', {disabled: _vm.disabled, negative: _vm.negative}],attrs:{"disabled":_vm.disabled}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }